'use client';

import { getEventContentTexts } from '@eliadmin/core/src/utils/project-content-text';
import type { EventDetail } from '@eliadmin/core/src/api/events/events-api';
import { HtmlDescription } from '../../shared/html-description';
import { cn } from '@eliadmin/core/src/utils/style-utils';

interface EventServicesProps {
  event: EventDetail;
}

export function EventServices({ event }: EventServicesProps) {
  const content = getEventContentTexts(event)?.find(field => field.id === 5)?.value;

  if (!content) return null;

  return (
    <HtmlDescription
      content={content}
      className={cn(
        'w-full bg-[#F6F6F6] p-6 text-black sm:p-8',
        'ea-course-event__description-content',
      )}
    />
  );
}
